import { render, staticRenderFns } from "./FilterCurrent.vue?vue&type=template&id=2ec146b8&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./FilterCurrent.vue?vue&type=script&lang=ts"
export * from "./FilterCurrent.vue?vue&type=script&lang=ts"
import style0 from "./FilterCurrent.vue?vue&type=style&index=0&id=2ec146b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec146b8",
  null
  
)

export default component.exports